export const HEAT_SOURCES = [
  { displayName: 'mountain', code: 'ht_geo' },
  { displayName: 'ground', code: 'ht_ground' },
  { displayName: 'outAndExhaustAir', code: 'ht_air' },
  { displayName: 'other', code: 'ht_other' }
] as const;

export type HeatSource = (typeof HEAT_SOURCES)[number];
